<h2 mat-dialog-title>Impression certification</h2>
<div mat-dialog-content>
  <div class="formContainer">
    <div class="form-group">
      <p><b>Bien :</b> {{ data.prop.name }}</p>
      <p><b>Propriétaire :</b> {{ UserHelper.userSummmaryDisplayName(data.prop.owner) }}</p>
      <p *ngIf="!ownerAddressExists">
        <mat-icon color="warn" class="align-bottom mr-2">warning</mat-icon>L'adresse du propriétaire
        n'est pas définie !
      </p>
    </div>
    <div class="form-group text-center">
      <button mat-flat-button class="m-2" color="primary" appTooltip="Imprimer la carte d'identité">
        <a style="color: white;" [href]="propertyHelper.getIdCardDocumentPrintUrl(data.prop)" target="_blank">Carte
          ID</a>
      </button>
      <button mat-flat-button class="m-2" color="primary" appTooltip="Imprimer le certificat">
        <a style="color: white;" [href]="propertyHelper.getCertificateDocumentPrintUrl(data.prop)"
          target="_blank">Certificat</a>
      </button>
      <button mat-flat-button class="m-2" color="primary" appTooltip="Imprimer l'adresse'"
        [disabled]="!ownerAddressExists">
        <a style="color: white;" [href]="propertyHelper.getOwnerAddressDocumentPrintUrl(data.prop)"
          target="_blank">Adresse</a>
      </button>
    </div>
    <div class="form-group text-center">
      <button mat-flat-button class="m-2" color="primary" mat-dialog-close appTooltip="Fermer" (click)="close()">
        Fermer
      </button>
    </div>
  </div>
</div>
